var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mainReducer = void 0;

exports.mainReducer = function (state, action) {
  switch (action.type) {
    case 'REGISTER_MODULE':
      return Object.assign(Object.assign({}, state), {
        modules: Object.assign(Object.assign({}, state.modules), _defineProperty({}, action.moduleId, action.module))
      });

    case 'SET_ADMIN_MODULE_STORE':
      return Object.assign(Object.assign({}, state), {
        modules: Object.assign(Object.assign({}, state.modules), _defineProperty({}, action.moduleId, Object.assign(Object.assign({}, state.modules[action.moduleId]), {
          store: action.store
        })))
      });

    case 'SET_PAGE_PROPS':
      return Object.assign(Object.assign({}, state), {
        pageProps: action.pageProps
      });

    case 'SET_LAST_MODULE_ID':
      return Object.assign(Object.assign({}, state), {
        lastModuleId: action.moduleId
      });

    default:
      return state;
  }
};